<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-01-10 09:08:13
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-03-22 20:07:54
 -->
<template>
  <div>
    <template v-for="button in buttonList">
      <!-- <el-popover v-if="button.type == 'pop'" placement="top" width="160" v-model="visible">
        <p>{{button.tipText}}</p>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="close">取消</el-button>
          <el-button type="primary" size="mini" @click="operate(button)">确定</el-button>
        </div>
        <el-button slot="reference" @click="open">{{button.btnText}}</el-button>
      </el-popover> -->
      <!-- <el-popconfirm
        v-if="button.type == 'pop'"
        :title="'来阿斯顿撒觉得很愧疚啊还是恐惧'"
        v-model="visible"
        @confirm="operate(button)"
        @cancel="close"
      >
        <el-button slot="reference">{{button.btnText}}</el-button>
      </el-popconfirm> -->
      <el-button v-if="button.type == 'confirm'" type="text" @click="operate(button, 'confirm')">{{button.btnText}}</el-button>
      <el-button v-else type="text" @click="operate(button)">{{button.btnText}}</el-button>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  props: {
    // 按钮描述
    buttonList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      visible: true // 控制popover显示/隐藏
    }
  },

  created() {},

  components: {},

  computed: {},

  methods: {
    // popover——关闭
    open() {
      this.visible = true
    },
    // popover——关闭
    close() {
      this.visible = false
    },
    // 确认——操作
    operate(data, type) {
      if (type == 'confirm') {
          this.$confirm(data.confirmText, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$emit(data.eventName)
        }).catch(() => {})
      } else {
          this.$emit(data.eventName)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.el-button {
  border: none !important;
  background-color: transparent !important;
  color: #FF8C42;
}
</style>



// WEBPACK FOOTER //
// src/base/button/index.vue